import React from "react";
import { useSelector } from "react-redux";

import TableHead from "../../../../components/UI/TableUI/TableHead";
import { OFFICER_TABLE_HEADERS } from "../../utils/userTable.config";
import NoDataDisplay from "../../../../components/UI/NoDataDisplay";
import MobileActionHeader from "../../../../components/UI/headingsUI/MobileActionHeader";
import { OFFICER_SEARCH_OPTIONS } from "../../utils/userTable.config";
import UsePermissionsClaim from "../../../../CustomHooks/UsePermissionsClaim";
import FilterSearch from "../../../../components/common/FilterSearch";
import { setTableHeight } from "../../../../functions/setTableHeight";
import sortDataByAlphabetically from "../../../../functions/sorting/sortDataByAlphabetically";
import { formatDate } from "../../../../functions/dateTime/formatDate";
import PhoneDisplay from "../PhoneDisplay";

const OfficerList = ({ officersData }) => {
  const isSorted = useSelector((state) => state.data.isSorted);
  let dataList = isSorted
    ? officersData
    : sortDataByAlphabetically(officersData, ["fullName"]);
  const isDataAvailable = officersData.length > 0;
  const { checkPermission } = UsePermissionsClaim();
  const permAddOfficer = checkPermission("add_officer");

  return (
    <>
      <MobileActionHeader
        title="All Officer"
        navigate={"/user/add-officer"}
        btnText={permAddOfficer ? "Add Officer" : undefined}
      />
      <FilterSearch
        searchCategories={OFFICER_SEARCH_OPTIONS}
        addBtnNavigation={"/user/add-officer"}
        addBtnText={permAddOfficer ? "Add Officer" : undefined}
      />
      <div className={`table-container ${setTableHeight(isDataAvailable)}`}>
        <table className={`table ${!isDataAvailable ? "relative" : ""}`}>
          <tbody>
            <TableHead headList={OFFICER_TABLE_HEADERS} />
            {isDataAvailable ? (
              <>
                {dataList.map((data, index) => {
                  return (
                    <tr className="table-row" key={index}>
                      <td>{index + 1}</td>
                      <td>
                        {data.fullName}
                        <br></br>
                        <PhoneDisplay
                          phone={data.phoneNumber}
                          isVerified={data.isPhoneVerified}
                        />
                      </td>
                      <td>{formatDate(data.createdAt)}</td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <NoDataDisplay />
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default OfficerList;
